
const AsciiTree = {

	parse (str){
		var list = [],
			open = [],
			maxDepth = 0,
			rows = [];

		str.split("\n").map((line) => {
			var m = line.match(/^(\t+)?(.+)$/),
				depth = m && m[1] ? m[1].length : 0,
				text = (m && m[2]) ? m[2] : "";

			// 行のパース
			list.push({
				depth,
				text,
				line
			});

			// 最深の階層を調べる
			maxDepth = Math.max(maxDepth, depth);
		});


		while(maxDepth--){
			open.push(false);
		}

		list.map((r, i) => {
			// ルート
			if(! r.depth){
				return rows.push(r.text);
			}

			// とりあえずクローズ？
			open[r.depth] = false;

			// 閉じるかどうかのチェック
			// 同じ階層の物が以降の行で、より浅い階層の行より前に無い場合閉じる
			var checked = false;

			list.slice(i+1).map((s) => {
				if(checked) return;
				if(s.depth < r.depth){
					checked = true;
					return;
				}
				if(s.depth === r.depth){
					open[r.depth] = true;
					checked = true;
					return;
				}
			});

			// 罫線を組み立てて結果行を生成していく
			// open されている親は｜で表現、そうでないなら空白
			var line = [];

			$.times(r.depth - 1, (index) => {
				if(open[index]){
					line.push("│");
				} else {
					line.push("　");
				}
			});

			line.push(open[r.depth] ? "├" : "└");
			line.push(r.text);

			rows.push(line.join(" "));
		});

		return rows.join("\n");
	}

};

export default AsciiTree;



// WEBPACK FOOTER //
// ./src/js/lib/asciitree.js